var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button button-icon white",on:{"click":_vm.setNextOption}},[_c('font-icon',{attrs:{"icon":_vm.currentOption.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }